/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:00:23
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/loadingPage.js
 */
export default {
    // loading-page组件
    loadingPage: {
        loadingText: '正在加载',
        image: '',
        loadingMode: 'circle',
        loading: false,
        bgColor: '#ffffff',
        color: '#C8C8C8',
        fontSize: 19,
        loadingColor: '#C8C8C8'
    }
}
